var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStratPartner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6668 32C26.9261 32 32.0002 26.9259 32.0002 20.6667C32.0002 14.4075 26.9261 9.33337 20.6668 9.33337C14.4076 9.33337 9.3335 14.4075 9.3335 20.6667C9.3335 26.9259 14.4076 32 20.6668 32Z",
    fill: "#E8DFFB",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 54.6667C2 49.716 3.96666 44.968 7.46734 41.4673C10.968 37.9667 15.716 36 20.6667 36C25.6174 36 30.3653 37.9667 33.866 41.4673C37.3667 44.968 39.3333 49.716 39.3333 54.6667H2Z",
    fill: "#E8DFFB",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0269 13.3333C37.4544 11.6537 39.3408 10.4269 41.455 9.80325C43.5693 9.17961 45.8196 9.18623 47.9301 9.82227C50.0407 10.4583 51.9199 11.6962 53.3375 13.3842C54.7551 15.0722 55.6495 17.1371 55.9112 19.3258C56.1729 21.5145 55.7905 23.7321 54.8108 25.7067C53.8312 27.6814 52.2968 29.3274 50.3957 30.4431C48.4946 31.5588 46.3093 32.0958 44.1076 31.9882C41.9059 31.8806 39.7834 31.1331 38.0002 29.8373C37.5277 29.49 37.082 29.1076 36.6669 28.6933",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3335 36.7733C42.1199 35.9455 45.061 35.7793 47.9229 36.2881C50.7848 36.7968 53.4885 37.9664 55.8189 39.7039C58.1492 41.4413 60.042 43.6986 61.3465 46.2962C62.6511 48.8937 63.3315 51.7599 63.3335 54.6667H46.0002",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStratPartner);
export default __webpack_public_path__ + "static/media/strat_partner.42d590ab362ea1f2019f27d57ec4ca42.svg";
export { ForwardRef as ReactComponent };